// extracted by mini-css-extract-plugin
export default {"Overlay":"Loading_Overlay__qs7V9","Spinner":"Loading_Spinner__84lyU","spin":"Loading_spin__yTYiX","Text":"Loading_Text__H2nze"};